import { Auth } from "@/service/auth";
import store from "@/store";
import { checkReservation } from "@/service/requireReservation";
export function requireAuth(to: any, from: any, next: any) {
  let auth = new Auth();
  if (!auth.loggedIn()) {
    auth.authOut();
    goLoginPage(to, next);
  } else {
    // 画面遷移時も、前回更新から5分以上なら認証更新の完了を待つ。
    Auth.ensureSessionRenewed().then((isSessionAvailable: boolean) => {
      if (!isSessionAvailable) {
        if (store.getters["Authentication/sessionConnectionProblem"]) {
          next(false);
        } else {
          auth.authOut();
          goLoginPage(to, next);
        }
        return;
      }
      if (store.getters["Authentication/timerRefeshToken"] == null) {
        auth.ensureSessionForScreen(true).then((isAuth: any) => {
        if (isAuth) {
          auth.refreshToken();
          store.dispatch(
            "Authentication/setTimerRefeshToken",
            auth.timerRefreshToken
          );
          checkReservation(to, next);
        } else {
          if (store.getters["Authentication/sessionConnectionProblem"]) {
            next(false);
          } else {
            auth.authOut();
            goLoginPage(to, next);
          }
        }
        }, (err: any) => {
          auth.authOut();
          goLoginPage(to, next);
        });
      } else {
        checkReservation(to, next);
      }
    });
  } 
}

function goLoginPage(to: any, next: any) {
  let loginName = to.meta + "login";
  next({
    name: loginName,
    query: { redirect: to.fullPath }
  });
}
